import * as React from 'react'

import { XIcon } from 'lucide-react'
import { inject, observer } from 'mobx-react'

import SlackBarStore from '~/client/src/shared/stores/ui/SlackBar.store'

import './ImagePreview.scss'

interface IImagePreview {
  slackBarStore?: SlackBarStore
  className?: string
  removeImage?: () => void
  removeTopPosition?: number
  removeRightPosition?: number
}

@inject('slackBarStore')
@observer
export default class ImagePreview extends React.Component<IImagePreview> {
  public store: SlackBarStore

  public constructor(props: IImagePreview) {
    super(props)
    this.store = props.slackBarStore
  }

  public componentWillUnmount() {
    this.store.hidePreview()
  }

  public render() {
    const { className = 'preview-image-wrapper' } = this.props
    return (
      <div className={className}>
        {this.renderRemoveImage()}
        <div className="preview-image-container col y-center">
          <div>{this.props.children}</div>
        </div>
      </div>
    )
  }

  private renderRemoveImage() {
    const { removeImage, removeRightPosition, removeTopPosition } = this.props
    if (removeImage) {
      return (
        <div
          onClick={removeImage}
          style={{
            top: removeTopPosition || 0,
            right: removeRightPosition || 0,
            zIndex: 2,
          }}
          className="absolute brada24 bg-dark row x-center"
        >
          <XIcon size={16} className="remove-icon" />
        </div>
      )
    }
  }
}
